 import { ActionReducerMap } from '@ngrx/store';

import { routerReducer } from '@ngrx/router-store';
import { IAppState } from '../state/app.state';
import { companyReducers } from './company.reducers';
import { userReducers } from './user.reducers';
import { agentReducers } from './agent.reducers';
import { manufacturerReducers } from './manufacturer.reducers';
import { materialReducers } from './material.reducers';
import { companyEmployeeReducers } from './companyEmployee.reducers';
import { formulationReducers } from './formulation.reducers';
import { mloReducers } from './mlo.reducers';
import { soReducers } from './so.reducers';
import { CustomerReducers } from './customer.reducers';
import { tasksReducers } from './tasks.reducers';
import { uotReducers } from './uot.reducers';
import { allergenReducers } from './allergen.reducers';
import { uomReducers } from './uom.reducers';
import { poReducers } from './po.reducer';
import { warhouseReducers } from './warehouse.reducer';
import { DocumentsReducers } from './documents.reducers';
import { HaccpReducers } from './haccp.reducers';
import { TraceabilityReducers } from './traceability.reducers';
import { globalDocumentsReducers } from './globalDocuments.reducers';


// import { branchReducers } from './branch.reducers';


export const appReducers: ActionReducerMap<IAppState, any> = {
  router: routerReducer,
  users: userReducers,
//   branch: branchReducers
    company: companyReducers,
    agent: agentReducers,
    manufacturer: manufacturerReducers,
    material: materialReducers,
    companyEmployee: companyEmployeeReducers,
    formulation: formulationReducers,
    mlo: mloReducers,
    so: soReducers,
    customer: CustomerReducers,
    tasks: tasksReducers,
    uom: uomReducers,
    uot: uotReducers,
    allergen: allergenReducers,
     warehouse:warhouseReducers,
    po:poReducers,
    documents: DocumentsReducers,
    haccp:HaccpReducers,
    traceability:TraceabilityReducers,
    globalDocuments: globalDocumentsReducers,

};
